// extracted by mini-css-extract-plugin
export default {"editButton":"DimensionsStatus_editButton__9xh3H"};